export default __webpack_public_path__ + "static/media/one-plus-helemets-xs.3c9c0282.glb";